import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/cuenta/login',
    name: 'Login',
    component: () => import('../views/cuenta/Login.vue')
  },
  {
    path: '/catalogos/dispositivos',
    name: 'Dispositivos',
    component: () => import('../views/catalogos/Dispositivos.vue')
  },
  {
    path: '/calendario/festivos',
    name: 'Festivos',
    component: () => import('../views/calendario/Festivos.vue')
  },
  {
    path: '/calendario/justificacion',
    name: 'Justificacion',
    component: () => import('../views/calendario/Justificacion.vue')
  },
  {
    path: '/catalogos/horarios',
    name: 'Horarios',
    component: () => import('../views/catalogos/Horarios.vue')
  },
  {
    path: '/catalogos/periodos',
    name: 'Periodos',
    component: () => import('../views/catalogos/Periodos.vue')
  },
  {
    path: '/catalogos/incidencias',
    name: 'Incidencias',
    component: () => import('../views/catalogos/Incidencias.vue')
  },
  {
    path: '/catalogos/lugaresChecado',
    name: 'LugaresChecado',
    component: () => import('../views/catalogos/LugaresChecado.vue')
  },
  {
    path: '/personal',
    name: 'Personal',
    component: () => import('../views/personal/Index.vue')
  },
  {
    path: '/personal/datos/:rfc',
    name: 'Datos',
    component: () => import('../views/personal/Datos.vue')
  },
  {
    path: '/personal/incidencias/:rfc',
    name: 'IncidenciasPersonal',
    component: () => import('../views/personal/Incidencias.vue')
  },
  {
    path: '/reportes',
    name: 'Reportes',
    component: () => import('../views/Reportes.vue')
  },
  {
    path: '/configuracion/actualizacion',
    name: 'Actualizacion',
    component: () => import('../views/configuracion/Actualizacion.vue')
  },
  {
    path: '/configuracion/usuarios',
    name: 'Usuarios',
    component: () => import('../views/configuracion/Usuarios.vue')
  },
  {
    path: '/visor/incidencias',
    name: 'IncidenciasVisor',
    component: () => import('../views/visor/Incidencias.vue')
  },
  {
    path: '/visor',
    name: 'LoginVisor',
    component: () => import('../views/visor/Login.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Error',
    component: () => import('../views/error/PageNotFound.vue')
  }
]

const router = createRouter({
  //mode: 'history',
  history: createWebHistory(process.env.BASE_URL),
  //history: createWebHistory(),
  routes
})

export default router
